module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Profile_02-22453b71a0ce610109e8460d0e176e9f.png";